<template>
    <Page type="gray" :nopadding="true">
        <template v-slot:body>
            <span class="text-900 font-medium mb-4 px-3 justify-content-start text-left
                xl:my-5 lg:my-4 md:my-3
                text-3xl xl:text-6xl lg:text-5xl md:text-4xl
                hidden xl:flex lg:flex md:flex">
                {{ header[this.lang_].title }}
            </span>
            <MultiPage />
        </template>
    </Page>
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import MultiPage from       '@/components/personal/wallet/MultiPage.vue'
import Page         from    '@/components/sides/Page.vue' 
import { mapActions } from  'vuex'

export default {
    data() {
        return {
            header: {
                en: { title: 'Wallet' },
                ru: { title: 'Кошелек' }
            },
        }
    },
    components: {
        MultiPage,
        Page
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    methods: {
        ...mapActions(['UpdateHeader']),
        updateHeader() {
            this.UpdateHeader({
                title: this.header[this.lang_].title,
                backButton: false,
                backButtonUrl: '/',
                profileButton: false
            });
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)
        this.updateHeader()
    }
}
</script>